import React from 'react';
import DefaultModal from '../../../../components/default/DefaultModal';

interface Props {
    show: boolean;
    handleClose: () => void;
    onSelectReportType: (reportType: string) => void;
}

const ReportTypeModal = ({ show, handleClose, onSelectReportType }: Props) => {
    const reportTypes = [
        { value: 'base', label: 'Reporte Base' },
        { value: 'reporte1', label: 'Reporte 1' },
        { value: 'reporte2', label: 'Reporte 2' },
        { value: 'reporte3', label: 'Reporte 3' }
    ];

    const handleSelect = (reportType: string) => {
        onSelectReportType(reportType);
        handleClose();
    };

    return (
        <DefaultModal
            show={show}
            handleClose={handleClose}
            title="Seleccionar tipo de reporte"
            backdrop={true}
            showFooter={false}
        >
            <div className="row">
                <div className="col-12">
                    <p className="mb-3">Seleccione el tipo de reporte que desea descargar:</p>
                    <div className="list-group">
                        {reportTypes.map((report) => (
                            <button
                                key={report.value}
                                type="button"
                                className="list-group-item list-group-item-action"
                                onClick={() => handleSelect(report.value)}
                            >
                                <i className="fa fa-file-excel me-2"></i>
                                {report.label}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-12 text-end">
                    <button className="btn btn-secondary" onClick={handleClose}>
                        Cancelar
                    </button>
                </div>
            </div>
        </DefaultModal>
    );
};

export default ReportTypeModal;
